import React from 'react';
import cx from 'classnames';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import ThankYouNote from 'assets/images/invitations/ThankYouNote.svg';
import MessageBird from 'assets/images/invitations/MessageBird.svg';
import PlaceCardIcon from 'assets/images/invitations/PlaceCardIcon.svg';

import { CARD_TYPES } from '../../../../constants/CardTypes';
import styles from './ProofModal.module.less';

const ModalBodyText = {
  [CARD_TYPES.place]:
    'If so, you’ll be able to assign guest names and tables if you’d like to do so.',
  [CARD_TYPES.thankyou]: "If so, we'll help you customize the inside of your cards and envelopes.",
  generic: "If so, we'll help you address your envelopes for free!",
};

export const ModalIcon = {
  [CARD_TYPES.place]: PlaceCardIcon,
  [CARD_TYPES.thankyou]: ThankYouNote,
  generic: MessageBird,
};

const ProofIncreaseConfirmModal = ({ closeCallback, onConfirmAction, cardType }) => {
  return (
    <div>
      <div className="modal-header">
        <img
          src={ModalIcon[cardType] || ModalIcon.generic}
          alt="Customizing a proof"
          className={styles.svg}
        />
        <h2 className={cx('modal-title', styles.title)}>
          Are you sure you want to increase quantity?
        </h2>
      </div>
      <div className="modal-body">
        <p className={cx('text-left', styles.text)}>
          {ModalBodyText[cardType] || ModalBodyText.generic}
        </p>
      </div>
      <div className="modal-footer">
        <div className="text-group row">
          <ButtonV2 onClick={closeCallback} variant="secondary">
            Cancel
          </ButtonV2>
          <ButtonV2 onClick={onConfirmAction} variant="primary">
            Increase Quantity
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

export default ProofIncreaseConfirmModal;
